import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAddressProps {
  address: string;
}

export const Address: React.FC<IAddressProps> = ({ address }) => {
  return (
    <div className={styles['address']}>
      <UIText2 color="text-primary-default">{address}</UIText2>
    </div>
  );
};
